import React from 'react'

import { Spinner } from '@wartek-id/spinner'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'
import { KinerjaHarianRoleProvider } from 'app/KinerjaHarian/components/KinerjaHarianRoleProvider'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { UpsertKinerjaHarianLogsPage } from 'app/KinerjaHarian/pages/UpsertKinerjaHarianLogsPage'
import useKinerjaHarianPS from 'app/KinerjaHarian/hooks/useKinerjaHarianPS'

import type { NextPageContext } from 'next'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ps-enabled'] || false
    const enabledAsPegawai = toggle?.['kinerja-ps-pegawai-enabled'] || false

    if (!enabled || !enabledAsPegawai) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

function Page() {
  const { basePath, contents, onUpsert, periodYear, isLoading, isSubmitting } =
    useKinerjaHarianPS()

  if (isLoading) {
    return (
      <div
        role="alert"
        className="flex flex-col items-center justify-center h-screen gap-4 pt-9"
        aria-busy="true"
      >
        <Spinner />
      </div>
    )
  }

  return (
    <UpsertKinerjaHarianLogsPage
      basePath={basePath}
      contents={contents}
      onUpsert={onUpsert}
      periodYear={periodYear}
      isSubmitting={isSubmitting}
    />
  )
}

function WrapperPage() {
  return (
    <PageGuardPSPegawai>
      <KinerjaTipeProvider tipe="SPF">
        <KinerjaHarianRoleProvider role="PS">
          <Page />
        </KinerjaHarianRoleProvider>
      </KinerjaTipeProvider>
    </PageGuardPSPegawai>
  )
}

WrapperPage.Layout = KinerjaLayout

WrapperPage.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default WrapperPage
